import logger from "../../../utils/logger";
import React, { useState } from "react";
import {
  Card,
  Col,
  Container,
  Label,
  Row,
  Button,
  Form,
  Spinner,
  Input,
  CardBody,
  Alert,
  InputGroup,
} from "reactstrap";

// redux
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { resetPassword } from "../../../slices/apps/authSlice";

// router
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// görsel importlar
import Logo from "../../../assets/images/logo/metiner_avantaj_logo.png";

const ResetPassword = () => {
  document.title = "Yeni Şifre Belirle | Metiner Avantaj+";

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const phoneNumber = location.state?.phoneNumber;

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

  const { resetPasswordLoading } = useSelector(
    (state) => ({
      resetPasswordLoading: state.auth.resetPasswordLoading,
    }),
    shallowEqual
  );

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Lütfen yeni şifrenizi giriniz.")
        .min(6, "Şifreniz en az 6 karakter olmalıdır."),
      confirmPassword: Yup.string()
        .required("Lütfen şifrenizi tekrar giriniz.")
        .oneOf([Yup.ref("password"), null], "Şifreler eşleşmiyor."),
    }),
    onSubmit: async (values) => {
      setSuccessMessage("");
      setErrorMessage("");
      try {
        await dispatch(
          resetPassword({
            phoneNumber: phoneNumber,
            newPassword: values.password,
          })
        ).unwrap();

        setSuccessMessage(
          "Şifreniz başarıyla güncellendi. Giriş sayfasına yönlendiriliyorsunuz..."
        );

        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } catch (error) {
        logger.error("Reset password failed:", error);
        setErrorMessage(
          error.message || "Bir hata oluştu. Lütfen tekrar deneyin."
        );
      }
    },
  });

  return (
    <React.Fragment>
      <div className="auth-page-wrapper d-flex justify-content-center align-items-center min-vh-100">
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="text-center pt-5">
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={Logo} alt="Metiner Avantaj+" height="100" />
                    </Link>
                  </div>
                  <CardBody className="p-lg-5 p-4">
                    {successMessage && (
                      <Alert color="success" className="text-center">
                        {successMessage}
                      </Alert>
                    )}
                    {errorMessage && (
                      <Alert color="danger" className="text-center">
                        {errorMessage}
                      </Alert>
                    )}

                    {!successMessage && (
                      <Form
                        onSubmit={validation.handleSubmit}
                        autoComplete="off"
                      >
                        <Row className="gy-3">
                          <Col lg={12}>
                            <Label>Yeni Şifre</Label>
                            <InputGroup>
                              <span
                                className="input-group-text"
                                style={{ width: "44px" }}
                              >
                                <i
                                  onClick={() => setPasswordShow(!passwordShow)}
                                  style={{ cursor: "pointer", color: "gray" }}
                                  className={
                                    passwordShow
                                      ? "ri-eye-off-fill align-middle"
                                      : "ri-eye-fill align-middle"
                                  }
                                ></i>
                              </span>
                              <Input
                                type={passwordShow ? "text" : "password"}
                                name="password"
                                className="form-control"
                                placeholder="******"
                                value={validation.values.password}
                                onChange={validation.handleChange}
                                invalid={
                                  !!(
                                    validation.touched.password &&
                                    validation.errors.password
                                  )
                                }
                              />
                            </InputGroup>
                            {validation.touched.password &&
                              validation.errors.password && (
                                <div className="d-block invalid-feedback">
                                  {validation.errors.password}
                                </div>
                              )}
                          </Col>

                          <Col lg={12}>
                            <Label>Yeni Şifre (Tekrar)</Label>
                            <InputGroup>
                              <span
                                className="input-group-text"
                                style={{ width: "44px" }}
                              >
                                <i
                                  onClick={() =>
                                    setConfirmPasswordShow(!confirmPasswordShow)
                                  }
                                  style={{ cursor: "pointer", color: "gray" }}
                                  className={
                                    confirmPasswordShow
                                      ? "ri-eye-off-fill align-middle"
                                      : "ri-eye-fill align-middle"
                                  }
                                ></i>
                              </span>
                              <Input
                                type={confirmPasswordShow ? "text" : "password"}
                                name="confirmPassword"
                                className="form-control"
                                placeholder="******"
                                value={validation.values.confirmPassword}
                                onChange={validation.handleChange}
                                invalid={
                                  !!(
                                    validation.touched.confirmPassword &&
                                    validation.errors.confirmPassword
                                  )
                                }
                              />
                            </InputGroup>
                            {validation.touched.confirmPassword &&
                              validation.errors.confirmPassword && (
                                <div className="d-block invalid-feedback">
                                  {validation.errors.confirmPassword}
                                </div>
                              )}
                          </Col>

                          <Col lg={12} className="mt-4">
                            <Button
                              type="submit"
                              color="primary"
                              className="w-100"
                              disabled={resetPasswordLoading}
                            >
                              {resetPasswordLoading ? (
                                <>
                                  <Spinner size="sm" className="me-2" />{" "}
                                  Güncelleniyor...
                                </>
                              ) : (
                                "Şifreyi Güncelle"
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    )}

                    <div className="mt-4 text-center">
                      <p className="mb-0">
                        Şifrenizi hatırlıyor musunuz?{" "}
                        <Link
                          to="/login"
                          className="fw-semibold text-primary text-decoration-underline"
                        >
                          Giriş Yap
                        </Link>
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        <footer className="footer h-auto pb-2">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center text-muted">
                  <p className="mb-2" style={{ letterSpacing: "0.8px" }}>
                    Metiner Avantaj+ &copy; {new Date().getFullYear()} | 0 352 3
                    555 444 | metiner@boschservice.com.tr
                    <br />
                    <i className="mdi mdi-heart text-danger"></i> by{" "}
                    <a
                      href="https://kodexis.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      Kodexis
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
